import * as styles from "./css/Subheading.module.css";
import * as sharedStyles from "../css/Shared.module.css";
const Subheading = props => {
    return (<h2 class={`${styles.subheading} ${sharedStyles.shared}${props.class ? ` ${props.class}` : ``}`}>
            {props.children}
        </h2>);
};
export { Subheading };
